import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import { isLowContrast } from 'utils/colors';
import MultiColorDots from './MultiColorDots';

const styles = StyleSheet.create({
    regularText: {
        fontFamily: 'PDF Font',
        fontSize: 8,
    },
    variations: {
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'row',
    },
    variationColor: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0px 1px',
        marginBottom: 4,
        minWidth: '45px',
        maxWidth: '50px',
        textAlign: 'center',
    },
    variationColorLeft: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginRight: '6px',
        minWidth: '30px',
    },
    variationColorDot: {
        height: 20,
        width: 20,
        marginTop: 2,
        marginBottom: 2,
    },
    sectionHeader: {
        fontSize: 10,
        fontFamily: 'PDF Font Bold',
        marginBottom: 2,
        textTransform: 'uppercase',
    },
    pictureImage: {
        maxHeight: 50,
        maxWidth: 50,
        padding: 2,
    },
});

export type Color = {
    hexColors?: string[] | null;
    colorCode?: string | null;
    colorName?: string | null;
    variationImage?: string | null;
};

const ColorChart = ({
    colors,
    showVariationImages,
    left,
}: {
    colors?: Color[];
    showVariationImages: boolean;
    left?: boolean;
}) => {
    return (
        <View style={styles.variations}>
            {colors?.map((color, index) => {
                return (
                    <View
                        key={`${color.colorName ?? ''}` + index}
                        style={left ? styles.variationColorLeft : styles.variationColor}
                    >
                        {showVariationImages && (
                            <Image
                                cache={true}
                                style={styles.pictureImage}
                                src={color.variationImage ?? undefined}
                            ></Image>
                        )}
                        {!showVariationImages &&
                            color.hexColors &&
                            color.hexColors.length > 0 &&
                            (color.hexColors.length > 1 ? (
                                <MultiColorDots colors={color.hexColors} />
                            ) : (
                                <View
                                    style={{
                                        ...styles.variationColorDot,
                                        backgroundColor: color.hexColors[0] ?? '',
                                        borderRadius: left ? '1px' : 10,
                                        border: isLowContrast(color.hexColors[0]) ? '1px solid #c5c5c5' : '0',
                                    }}
                                />
                            ))}
                        {(color.colorName?.length ?? 0) > 0 && (
                            <Text style={styles.regularText}>{color.colorName}</Text>
                        )}
                        {(color.colorCode?.length ?? 0) > 0 && (
                            <Text style={styles.regularText}>({color.colorCode})</Text>
                        )}
                    </View>
                );
            })}
        </View>
    );
};

export default ColorChart;
